import { Result } from 'antd';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { Loading } from 'components/atoms/loading';
import { useCreateCustomerApiKey } from 'hooks/use-create-customer-api-key';
import { useQueryParamsFromWindow } from 'hooks/use-query-params';
import { API_KEY, logger } from 'services';

export const CustomerPortalMagicLink = () => {
  const queryParams = useQueryParamsFromWindow();
  const router = useHistory();

  const { mutateAsync } = useCreateCustomerApiKey();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const redirect = () => {
      const a = document.createElement('a');

      a.setAttribute('href', '/');
      a.click();
    };

    const token = queryParams.get('token') as string;
    const apiKeyStr = localStorage.getItem(API_KEY);

    if (apiKeyStr != null) {
      try {
        const apiKeyArr = JSON.parse(apiKeyStr);
        const apiKey = apiKeyArr?.at(1);

        if (apiKey) {
          router.push('/');

          return;
        }
      } catch (err) {
        // pass
      }
    }

    mutateAsync(
      { jwt: token },
      {
        onSuccess: (data) => {
          logger.debug('fetched api key for access token');
          localStorage.setItem(
            API_KEY,
            `["api_key", "${data?.apiKey}", ${data?.createdBy?.userId}, ${data?.apiKeyId}]`,
          );
          localStorage.setItem('customer_portal', 'true');
          setLoading(false);
          setError(false);
          redirect();
        },
        onError: (_error) => {
          setLoading(false);
          setError(true);
        },
      },
    );
  }, [mutateAsync, queryParams, router]);

  if (loading) {
    return (
      <Result
        icon={<Loading />}
        title={<FormattedMessage id="logging_in" />}
        subTitle={<FormattedMessage id="logging_in.subtitle" />}
      />
    );
  }

  if (error) {
    return (
      <Result
        status="403"
        title={<FormattedMessage id="unauthorized" />}
        subTitle={<FormattedMessage id="unauthorized.subtitle" />}
      />
    );
  }

  return <></>;
};
